import { useSession } from '../lib/session.js';

/**
 * Marca da loja no menu e na tela de acesso.
 *
 * P04: enquanto a logo original em PNG transparente ou SVG não for enviada, o
 * espaço mostra o monograma da loja em tamanho pequeno, marcado como
 * provisório. Nenhuma outra logo é desenhada e a miniatura do perfil não é
 * tratada como arquivo vetorial oficial.
 */
export function Logo({ size = 40 }: { size?: number }) {
  const { store, branding } = useSession();
  const name = store?.name ?? branding?.name ?? 'Auto Center GL';
  const logoUrl = (store?.brand?.logoUrl ?? branding?.brand?.logoUrl) || null;

  if (logoUrl) {
    return (
      <img
        className="brand-mark"
        src={logoUrl}
        width={size}
        height={size}
        alt={`Logo ${name}`}
        style={{ width: size, height: size, flexBasis: size }}
      />
    );
  }
  const initials = name
    .replace(/[^A-Za-zÀ-ÿ\s]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');

  return (
    <span
      className="brand-mark"
      style={{ width: size, height: size, flexBasis: size }}
      title="Logo provisória. Envie o arquivo original em Configurações > Loja e marca."
      aria-label={`Marca provisória de ${name}`}
    >
      {initials || 'GL'}
    </span>
  );
}
